import { useState, useRef } from "react";
import { StickyNote } from "lucide-react";

/**
 * Small notes icon shown next to a name; on hover displays a popover with the
 * note text. Returns null when notes is falsy.
 */
export function NotesHoverIcon({ notes, testid }) {
  const [open, setOpen] = useState(false);
  const hideTimer = useRef(null);

  if (!notes || !String(notes).trim()) return null;

  const cancelHide = () => {
    if (hideTimer.current) { clearTimeout(hideTimer.current); hideTimer.current = null; }
  };
  const scheduleHide = () => {
    cancelHide();
    hideTimer.current = setTimeout(() => setOpen(false), 120);
  };

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => { cancelHide(); setOpen(true); }}
      onMouseLeave={scheduleHide}
    >
      <span
        data-testid={testid || "notes-hover-icon"}
        className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-amber-100 text-amber-700 border border-amber-300 cursor-help"
        title="Questo elemento ha delle note"
      >
        <StickyNote className="h-3 w-3" />
      </span>
      {open && (
        <div
          onMouseEnter={cancelHide}
          onMouseLeave={scheduleHide}
          className="absolute top-full left-0 mt-1.5 z-50 w-72 bg-white border border-amber-200 rounded-lg shadow-xl p-3"
        >
          <div className="text-[10px] uppercase tracking-wider font-semibold text-amber-700 mb-1.5 flex items-center gap-1">
            <StickyNote className="h-3 w-3" /> Note
          </div>
          <p className="text-xs text-slate-700 whitespace-pre-wrap break-words">{notes}</p>
        </div>
      )}
    </span>
  );
}

export default NotesHoverIcon;
